import { HttpResult } from "widgets-for-react"

export namespace ZipCode {
  export interface CheckResponse {
    Street: string
    City: string
    houseNumber: number
    postcode: string
  }

  export const CheckRequest: (_:{postcode: string, houseNumber: number}) => Promise<HttpResult<CheckResponse>> =
  async (input) => {
    try {
      const endpoint = `/api/v1/postCodeCheck?zipCode=${input.postcode}&houseNumber=${input.houseNumber}`
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)
      
      let res = await fetch(endpoint, {
        method: 'get', credentials: 'include', headers: headers
      })
      
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json() as { Street: string, City: string }
      
      return {
        kind: 'result',
        status: 200,
        value: {
          ...json,
          houseNumber: input.houseNumber,
          postcode: input.postcode
        }
      }
    } catch {
      return {
        kind: 'failed',
        status: 500
      }
    }
  }
}